// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

 
const options = {
  order: ['htmlTag', 'cookie', 'localStorage', 'path', 'subdomain'],
  caches: ['cookie'],
};
 
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    debug: true,
    detection: options,
    fallbackLng: 'en-us',
    // lng: 'en-us',
    backend: {
      loadPath: function(lng) {
        const normalizedLang = Array.isArray(lng) && lng.length > 0 ? lng[0].toLowerCase() : "en-us";
        if (normalizedLang.includes("-")) {
          return `/locales/${normalizedLang}/translation.json`;
        }
 
        return `/locales/en-us/translation.json`; // Default to en-us if fallback is "en"
      },
    },
  });
 
export default i18n;